export const headerLangText: Record<
    string,
    {
        [key: string]: string;
    }
> = {
    us: {
        UserInfo: 'Review Your EcoFlow Power Journey with \n a Million Moments of Gratitude',
        SummaryEnd: '',
        ReferralInfo: 'Redeem your EcoCredits and get premium membership gifts, participate in special members-only events, and enjoy exclusive discounts.',
        Recommended: 'Thank you for supporting EcoFlow!',
        OrderInfo: '',
        EcoBenefits: 'Review Your EcoFlow Power Journey with a \nMillion Moments of Gratitude',
        AnswerAward: 'What are you most interested \nin using EcoFlow for?',
        CommonTitle: "EcoFlow Member's Festival",
    },
    it: {
        UserInfo: 'Review Your EcoFlow Power Journey with \n a Million Moments of Gratitude',
        SummaryEnd: '',
        ReferralInfo: 'Redeem your EcoCredits and get premium membership gifts, participate in special members-only events, and enjoy exclusive discounts.',
        Recommended: 'Thank you for supporting EcoFlow!',
        OrderInfo: '',
        EcoBenefits: 'Review Your EcoFlow Power Journey with a \nMillion Moments of Gratitude',
        AnswerAward: 'What are you most interested \nin using EcoFlow for?',
        CommonTitle: 'Il festival dei membri EcoFlow',
    },
    de: {
        UserInfo: 'Review Your EcoFlow Power Journey with \n a Million Moments of Gratitude',
        SummaryEnd: '',
        ReferralInfo: 'Redeem your EcoCredits and get premium membership gifts, participate in special members-only events, and enjoy exclusive discounts.',
        Recommended: 'Thank you for supporting EcoFlow!',
        OrderInfo: '',
        EcoBenefits: 'Review Your EcoFlow Power Journey with a \nMillion Moments of Gratitude',
        AnswerAward: 'What are you most interested \nin using EcoFlow for?',
        CommonTitle: 'EcoFlow Mitgliederfestival',
    },
    es: {
        UserInfo: 'Review Your EcoFlow Power Journey with \n a Million Moments of Gratitude',
        SummaryEnd: '',
        ReferralInfo: 'Redeem your EcoCredits and get premium membership gifts, participate in special members-only events, and enjoy exclusive discounts.',
        Recommended: 'Thank you for supporting EcoFlow!',
        OrderInfo: '',
        EcoBenefits: 'Review Your EcoFlow Power Journey with a \nMillion Moments of Gratitude',
        AnswerAward: 'What are you most interested \nin using EcoFlow for?',
        CommonTitle: 'Celebración de usuarios de EcoFlow',
    },
    fr: {
        UserInfo: 'Review Your EcoFlow Power Journey with \n a Million Moments of Gratitude',
        SummaryEnd: '',
        ReferralInfo: 'Redeem your EcoCredits and get premium membership gifts, participate in special members-only events, and enjoy exclusive discounts.',
        Recommended: 'Thank you for supporting EcoFlow!',
        OrderInfo: '',
        EcoBenefits: 'Review Your EcoFlow Power Journey with a \nMillion Moments of Gratitude',
        AnswerAward: 'What are you most interested \nin using EcoFlow for?',
        CommonTitle: "Festival des utilisateurs d'EcoFlow",
    },
    kr: {
        UserInfo: 'Review Your EcoFlow Power Journey with \n a Million Moments of Gratitude',
        SummaryEnd: '',
        ReferralInfo: 'Redeem your EcoCredits and get premium membership gifts, participate in special members-only events, and enjoy exclusive discounts.',
        Recommended: 'Thank you for supporting EcoFlow!',
        OrderInfo: '',
        EcoBenefits: 'Review Your EcoFlow Power Journey with a \nMillion Moments of Gratitude',
        AnswerAward: 'What are you most interested \nin using EcoFlow for?',
        CommonTitle: '2024 멤버십 데이',
    },
};
